import { Navigate, Outlet, useParams } from "@tanstack/react-router";
import { useSuspenseGqlQuery } from "@/lib/GraphQLCodegen/fetcher";
import { billingEntitiesQuery } from "@/app/Settings/Settings/GraphQL/billingEntitiesQuery";
import { useSettingsSupplier } from "@/app/Suppliers/Utils/useSettingsSupplier";

export function SupplierBillingLayout() {
  const { supplier } = useSettingsSupplier();
  const params = useParams({ strict: false }) as { entityId?: string };

  const { data } = useSuspenseGqlQuery(billingEntitiesQuery, {
    supplier_id: supplier?.id,
  });

  const defaultBillingEntity = supplier?.billingEntity;
  const billingEntities = data?.billingEntities ?? [];

  if (!supplier || !defaultBillingEntity) {
    return null;
  }

  const entityIdInScope =
    params.entityId &&
    billingEntities.some((entity) => entity.id === params.entityId);

  if (!entityIdInScope) {
    return (
      <Navigate
        from="/$tenant/$orgId/supplier/{-$supplierId}"
        to="/$tenant/$orgId/supplier/{-$supplierId}/settings/billing/$entityId"
        params={(prev) => ({ ...prev, entityId: defaultBillingEntity.id })}
        search={(prev) => prev}
        replace
      />
    );
  }

  return (
    <div className="space-y-12">
      <Outlet />
    </div>
  );
}
